import { FC, PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';
import { Error } from './custom-error/custom-error';

export const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  return <Sentry.ErrorBoundary fallback={<Error />}>{children}</Sentry.ErrorBoundary>;
};
